import React from "react";
import { getDefaultSettings } from "modules/helpers";

export const SettingsContext = React.createContext({
  settings: getDefaultSettings(),
  updateSettings: () => {
    return;
  },
});
